export default {
			acao: 'atualizar',
			ar_nota: '190207122223000170001247559',
			cnpj_destinatario: '05937634000199',
			cnpj_dist: '07122223000170',
			cnpj_transp: '15292743000150',
			end_dest: 'AV JORGE VIEIRA, 19',
			nome_destinatario: 'DROG RAGONETE E SILVA LTDA ME',
			nome_dist: 'MEDICAMENTOS EIRELI',
			numero_nota: '001247559',
			pos_entrega: '0',
			qtd_volumes: '1',
			serie_nota: '001',
			valor_mercadoria: '894.53'
		
};
